import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Flame } from "lucide-react";

const StreakChip = ({ userId }: { userId: string }) => {
  const { data } = useQuery({
    queryKey: ["contributor-streak", userId],
    queryFn: async () => {
      const { data } = await supabase
        .from("contributor_activity_streak")
        .select("current_streak_weeks, longest_streak_weeks, total_published")
        .eq("user_id", userId)
        .maybeSingle();
      return data;
    },
    enabled: !!userId,
  });

  if (!data || (data.current_streak_weeks ?? 0) < 1) return null;

  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-primary/30 bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary">
      <Flame className="h-3 w-3" />
      {data.current_streak_weeks} idea{data.current_streak_weeks === 1 ? "" : "s"} streak
    </span>
  );
};

export default StreakChip;